<template>
  <div class="companyAuthInfo">
    <div class="account-user">
      <span class="font-gray">登录账户：</span>{{ loginuser }}
      <span v-show="isAdmin">(管理员)</span>
    </div>
    <div class="segment-outer info-item">
      <div class="info-title">
        <span>企业资料</span>
        <!-- <div class="info-action">
          <span class="link-btn" @click="">查看详情</span>
        </div> -->
      </div>
      <div class="info-content">
        <div class="content-header">
          <div class="content-header-info">
            <div class="item-logo">
              <img :src="certificateInfo.companyLogo ? joinUrl(certificateInfo.companyLogo) : avatar1" alt="" />
              <div class="logo-upload-box">
                <el-upload
                  class="avatar-uploader"
                  :action="uploadAction"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :on-error="handleError"
                >
                  <span class="logo-edit">
                    <span class="upload-tip">修改</span>
                  </span>
                </el-upload>
              </div>
            </div>
            <div class="company-name">
              <div class="name-box">
                <div class="item-name" :title="businessLicenseResponse.companyName">
                  {{ businessLicenseResponse.companyName }}
                </div>
                <div class="item-status status-qy" :class="[`status-qy-${certificateInfo.certificateStatus}`]">
                  {{ certificateStatusResultMap[certificateInfo.certificateStatus] }}
                </div>
                <template v-if="isAdmin">
                  <span @click="handleCompDetail" class="link-btn">
                    {{ certificateInfo.certificateStatus == 0 ? '去认证' : '查看' }}
                  </span>
                </template>
                <span
                  class="company-tip"
                  v-if="
                    certificateInfo.certificateStatus === 3 &&
                    !managerInfo.companyCancelUpdateFlag &&
                    (managerInfo.latestCompanyCertificateStatus === 5 ||
                      managerInfo.latestCompanyCertificateStatus === 6)
                  "
                ></span>
              </div>
              <el-rate
                class="ver-m"
                v-model="certificateInfo.star"
                disabled
                text-color="#ff9900"
                disabled-void-color="#cedcdf"
              ></el-rate>
            </div>
          </div>
        </div>
        <div class="content-main">
          <div class="content-img">
            <el-image
              v-if="businessLicenseResponse.photoUploadUrl"
              :preview-src-list="[urlPrefix + businessLicenseResponse.photoUploadUrl]"
              :src="urlPrefix + businessLicenseResponse.photoUploadUrl"
              alt=""
            />
            <div class="content-tip">营业执照</div>
          </div>
          <div class="content-detail">
            <div class="detail-item">
              <div class="detail-label">社会信用代码：</div>
              <div class="detail-content">
                <el-tooltip :content="businessLicenseResponse.creditCode">
                  <span>{{ businessLicenseResponse.creditCode }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">法人姓名：</div>
              <div class="detail-content">
                <el-tooltip :content="businessLicenseResponse.corpName">
                  <span>{{ businessLicenseResponse.corpName }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">联系人姓名：</div>
              <div class="detail-content">
                <el-tooltip :content="certificateInfo.companyLinker">
                  <span>{{ certificateInfo.companyLinker }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">注册地址：</div>
              <div class="detail-content">
                <el-tooltip :content="businessLicenseResponse.registerAddress">
                  <span>{{ businessLicenseResponse.registerAddress }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">法人身份证号码：</div>
              <div class="detail-content">
                <el-tooltip :content="idCardDesensitization(corpResponse.identityCard)">
                  <span>{{ idCardDesensitization(corpResponse.identityCard) }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">联系人手机号：</div>
              <div class="detail-content">
                <el-tooltip :content="certificateInfo.contactMobile">
                  <span>{{ certificateInfo.contactMobile }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">营业期限：</div>
              <div class="detail-content">
                <el-tooltip :content="timeRange">
                  <span>{{ timeRange }}</span>
                </el-tooltip>
              </div>
            </div>
            <div class="detail-item">
              <div class="detail-label">注册手机号：</div>
              <div class="detail-content">
                <el-tooltip :content="corpResponse.registerMobile">
                  <span>{{ corpResponse.registerMobile }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer info-item">
      <div class="info-title">
        <span>管理员资料</span>
        <div class="info-action"></div>
      </div>
      <div class="info-content">
        <div class="content-header">
          <div class="content-header-info">
            <div class="item-logo">
              <img :src="managerInfo.userLogo ? joinUrl(managerInfo.userLogo) : avatar2" alt="" />
            </div>
            <div class="item-name">
              {{ managerInfo.managerName }}
            </div>
            <div class="item-status status-qy" :class="[`status-qy-${managerInfo.managerCertificateStatus}`]">
              {{ managerCertificateStatusResultMap[managerInfo.managerCertificateStatus] }}
            </div>
            <!-- 逻辑参考CompanyInfo中的管理员状态 -->
            <template
              v-if="isAdmin && managerInfo.managerCertificateStatus != 0 && certificateInfo.certificateStatus > 2"
            >
              <span @click="handleToAdminDtl" class="link-btn"> 查看 </span>
            </template>
            <span
              class="company-tip"
              v-if="
                managerInfo.managerCertificateStatus === 3 &&
                !managerInfo.cancelUpdateFlag &&
                (managerInfo.latestManagerCertificateStatus === 5 || managerInfo.latestManagerCertificateStatus === 6)
              "
            ></span>
          </div>
          <div class="content-header-action">
            <template
              v-if="
                isAdmin &&
                managerInfo.latestManagerCertificateStatus !== 1 &&
                managerInfo.latestManagerCertificateStatus !== 5 &&
                certificateInfo.certificateStatus > 2
              "
            >
              <span v-if="!managerInfo.cropState && managerInfo.id != 0" class="link-btn" @click="downloadTemplate"
                >下载委托书模板</span
              >
              <el-button
                v-if="!managerInfo.cropState && managerInfo.id != 0"
                type="primary"
                @click="handleUpdateEntrust"
                >更新委托书</el-button
              >
              <el-button type="primary" @click="handleUpdateManager">更换管理员</el-button>
            </template>
          </div>
        </div>
        <div class="content-main">
          <div class="content-img" v-if="!managerInfo.cropState && managerInfo.engagementLetterUrl">
            <el-image
              :preview-src-list="[joinUrl(managerInfo.engagementLetterUrl)]"
              :src="joinUrl(managerInfo.engagementLetterUrl)"
              alt=""
            />
            <div class="content-tip">企业委托书</div>
            <div v-if="managerInfo.engagementLetterExpireState" class="engagement-tip">
              <i class="icon"></i>
              <span>企业委托书已过期，请修改</span>
            </div>
          </div>
          <div class="content-detail">
            <div class="detail-item item-row">
              <div class="detail-label">管理员是否法人本人：</div>
              <div class="detail-content">
                <span class="manager-flag">
                  {{ managerInfo.id ? (managerInfo.cropState ? '是' : '否') : '' }}
                </span>
              </div>
            </div>
            <div class="detail-item item-row">
              <div class="detail-label">管理员身份证号：</div>
              <div class="detail-content">{{ idCardDesensitization(managerInfo.identityCard) }}</div>
            </div>
            <div class="detail-item item-row">
              <div class="detail-label">手机号：</div>
              <div class="detail-content">{{ managerInfo.adminMobile }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="segment-outer info-item">
      <div class="info-title">
        <span>承运方</span>
        <div class="info-action"></div>
      </div>
      <div class="info-content">
        <div class="content-main">
          <div class="content-detail">
            <div class="detail-item item-row">
              <div class="detail-label">承运商：</div>
              <div class="detail-content">{{ certificateInfo.carrierCompany }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EntrustForm
      @changeManager="dialogType = 2"
      @changeManagerSuccess="fetchManagerInfo"
      @changeEntrustSuccess="init"
      :type="dialogType"
      :visible.sync="entrustFormVisible"
    ></EntrustForm>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:13
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axiosNew from '@/api/axiosNew';
import newApi from '@/api/base.new.api';
import idcardBackPic from '@/assets/img/pic_idcard_bm.png';
import idcardfrontPic from '@/assets/img/pic_idcard_zm.png';
import avatar1 from '@/assets/img/setting/avatar48px_qy@2x.png';
import avatar2 from '@/assets/img/setting/avatar48px_gly@2x.png';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import { getFileUrlPrefix } from '@/utils';
import dayjs from 'dayjs';
import EntrustForm from './components/EntrustForm.vue';
import { idCardDesensitization } from '../../utils';
import { WUYI, vali } from '@/api/common';
export default {
  name: 'CompanyInfo',
  components: { EntrustForm },
  data() {
    return {
      uploadAction: newApi.newUploadImg,
      urlPrefix: '',
      identityCard: '',
      idcardBackPic: idcardBackPic,
      idcardfrontPic: idcardfrontPic,
      certificateStatus: 0, // 认证状态 0未认证 1审核中 2审核未通过 3已认证 4待更新 5更新审核中 6更新申请未通过
      faceCertificateStatus: false, // 管理员实名认证状态
      certificateInfo: {}, // 所有认证信息
      businessLicenseResponse: {}, // 营业执照信息
      corpResponse: {}, // 法人信息
      photoUploadViewer: '',
      otherPhotoViewer: '',
      avatar1,
      avatar2,
      managerInfo: {},
      entrustFormVisible: false,
      dialogType: 1,
      loginuser: '',
      isAdmin: false,
      certificateStatusResultMap: {
        0: '未认证',
        1: '审核中',
        2: '审核不通过',
        3: '已认证',
        4: '待更新',
        5: '更新审核中',
        6: '更新审核不通过'
      },
      managerCertificateStatusResultMap: {
        0: '未认证',
        1: '审核中',
        2: '审核未通过',
        3: '已认证',
        4: '待更新',
        5: '更新审核中',
        6: '更新审核不通过',
        99: '未升级'
      }
    };
  },
  computed: {
    timeRange() {
      if (!this.businessLicenseResponse.startDate && !this.businessLicenseResponse.endDate) {
        return '';
      }

      return (
        this.formatDate(this.businessLicenseResponse.startDate) +
        ' 至 ' +
        this.formatDate(this.businessLicenseResponse.endDate)
      );
    }
  },
  async created() {
    this.isAdmin = WUYI.currentData.user.isadmin;
    this.loginuser = WUYI.currentData.user.username;
    this.urlPrefix = await getFileUrlPrefix();
    this.init();
  },
  methods: {
    fetchData() {
      axiosNew.post(newApi.qryCerEnterpriseinfo).then(res => {
        this.certificateStatus = res.data.certificateStatus;
        this.faceCertificateStatus = res.data.faceCertificateStatus;
        this.certificateInfo = res.data;
        this.businessLicenseResponse = res.data.businessLicenseResponse || {};
        this.corpResponse = res.data.corpResponse;
        console.log(this.businessLicenseResponse.photoUploadUrl);
      });
    },
    fetchManagerInfo() {
      axiosNew.post(newApi.qryManagerinfo).then(res => {
        this.managerInfo = res.data;
      });
    },
    handleEdit() {
      if (this.certificateStatus !== 0) {
        this.$router.push({ path: '/companyAuthEdit' });
      }
    },
    handleToUpdateInfo() {
      this.$router.push({ path: '/companyInfoUpdate' });
    },
    showViewer(event, type) {
      if (!this[type]) {
        this[type] = new Viewer(event.target, {});
      }
      this[type].show();
    },
    formatDate(val, format = 'YYYY-MM-DD') {
      return val ? dayjs(val).format(format) : '长期有效';
    },
    downloadTemplate() {
      axiosNew.post(newApi.proxyStatementUrl).then(res => {
        window.open(this.urlPrefix + res.data.downloadUrl);
      });
    },
    handleUpdateEntrust() {
      this.dialogType = 1;
      this.entrustFormVisible = true;
    },
    handleUpdateManager() {
      this.dialogType = 2;
      this.entrustFormVisible = true;
    },
    init() {
      this.fetchData();
      this.fetchManagerInfo();
    },
    idCardDesensitization(val) {
      return idCardDesensitization(val);
    },
    handleCompDetail() {
      if (this.certificateInfo.certificateStatus == 0) {
        this.$router.push('/companyAuthEdit');
      } else {
        this.$router.push('/companyAuthInfo');
      }
    },
    // 查看管理员信息
    handleToAdminDtl() {
      this.$router.push({ path: '/adminAuthInfo' });
    },
    joinUrl(url) {
      if (!url) return '';
      if (url.startsWith('http')) return url;
      if (url.startsWith('/')) {
        url = url.substring(1);
      }
      return this.urlPrefix + url;
    },
    handleAvatarSuccess(res, file) {
      // 图片上传成功
      if (res.code == 0) {
        axiosNew
          .post(newApi.updateEnterprise, { companyCode: this.companyCode, photoUrl: res.data.fileUri })
          .then(res => {
            this.fetchData();
          });
      } else {
        this.$message.error(res.message);
      }
    },
    beforeAvatarUpload(file) {
      // 图片上传前验证
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt3M = file.size / 1024 / 1024 < vali.imgLimit;

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
      }
      if (!isLt3M) {
        this.$message.error(`上传图片大小不能超过${vali.imgLimit}MB!`);
      }
      return isImage && isLt3M;
    },
    handleError(res) {
      this.$message.error('图片上传失败，服务器错误!');
    }
  }
};
</script>

<style scoped>
.segment-item-box {
  margin: 40px 20px;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
.pic-preview {
  width: 192px;
  height: 120px;
  background-size: 100% 100%;
}
.pic-preview img {
  width: 100%;
  height: 100%;
}
.btn-group {
  padding: 30px 10px 0 40px;
  border-top: 1px solid #e8ecef;
}
.submit-btn {
  border: 1px solid #1cc466;
  color: #1cc466;
}
.idcard {
  display: flex;
}
.btn-bottom {
  margin: 40px;
}
</style>
<style>
.companyAuthInfo .self-brefore .el-input__inner {
  width: 386px;
}
.companyAuthInfo .el-form-item__label {
  color: #90a0b1;
}
</style>
<style lang="postcss" scoped>
.info-item {
  padding: 20px 24px;
  .link-btn {
    display: inline-block;
    color: #3399ff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    margin-left: 6px;
  }
  .company-tip {
    padding: 0 10px;
    line-height: 26px;
    color: #409eff;
    width: 42px;
    height: 16px;
    background: url(../../assets/img/setting/ico_qyxx_ygx.png) no-repeat;
    background-size: 42px 16px;
    margin-top: -20px;
    margin-left: 4px;
  }
  .info-title {
    color: #333;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    span {
      flex: 1;
    }
    .info-action {
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 6px;
      }
    }
  }
  .info-content {
    .content-header {
      height: 40px;
      display: flex;
      align-items: center;
      &-info {
        display: flex;
        align-items: center;
        flex: 1;
        overflow: hidden;
        .company-name {
          flex: 1;
          overflow: hidden;
          .name-box {
            display: flex;
            align-items: center;
            width: 100%;
          }
        }
      }
      &-action {
        display: flex;
        align-items: center;
        .el-button {
          margin-left: 6px;
        }
      }
      .item-logo {
        width: 40px;
        height: 40px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 8px;
          overflow: hidden;
        }
        margin-right: 12px;
        position: relative;
        .logo-upload-box {
          .logo-edit {
            opacity: 0;
            transition: all 0.3s;
            cursor: pointer;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            .upload-tip {
              position: absolute;
              text-align: center;
              left: 0;
              right: 0;
              bottom: 0;
              height: 14px;
              line-height: 14px;
              background-color: #000;
              color: #fff;
              font-size: 12px;
            }
          }
        }
        &:hover {
          .logo-edit {
            opacity: 1;
          }
        }
      }
      .item-name {
        color: #333;
        font-weight: 500;
        font-size: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .item-status {
        height: 22px;
        line-height: 20px;
        box-sizing: border-box;
        padding: 0 6px;
        text-align: center;
        color: var(--status-color);
        border: 1px solid var(--status-color);
        font-size: 12px;
        margin-left: 6px;
        border-radius: 2px;
        white-space: nowrap;
        &.status-qy {
          --status-color: #f35856;
          &-0 {
            --status-color: #f35856;
          }
          &-1 {
            --status-color: #ff9900;
          }
          &-2 {
            --status-color: #f35856;
          }
          &-3 {
            --status-color: #01d28e;
          }
          &-4 {
            --status-color: #ff9900;
          }
          &-5 {
            --status-color: #ff9900;
          }
          &-6 {
            --status-color: #f35856;
          }
          &-99 {
            --status-color: #f35856;
          }
        }
      }
    }
    .content-main {
      margin-top: 20px;
      display: flex;
      .content-img {
        width: 262px;
        margin-left: 52px;
        position: relative;
        .el-image {
          display: block;
          width: 100%;
          height: 164px;
        }
        .content-tip {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #aaa;
          margin-top: 8px;
          text-align: center;
        }
        .engagement-tip {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 64px;
          width: 222px;
          height: 36px;
          display: flex;
          align-items: center;
          background-color: rgba(3, 3, 3, 0.4);
          backdrop-filter: blur(10px);
          color: #fff;
          font-size: 14px;
          justify-content: center;
          border-radius: 4px;
          .icon {
            width: 16px;
            height: 16px;
            background-image: url(../../assets/img/setting/ico16px_popconfirm_ask2star@2x.png);
            background-size: 100% 100%;
            margin-right: 2px;
          }
        }
      }
      .content-detail {
        flex: 1;
        margin-left: 40px;
        overflow: hidden;
        flex-wrap: wrap;
        display: flex;
        line-height: 20px;
        align-items: flex-start;
        padding-top: 8px;
        height: fit-content;
        .detail-item {
          width: 33.3%;
          display: flex;
          color: #666;
          line-height: 20px;
          font-size: 14px;
          font-weight: 400;
          height: 20px;
          margin-bottom: 16px;
          &.item-row {
            width: 100%;
          }
          .detail-label {
            text-align: right;
            width: 140px;
          }
          .detail-content {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: flex;
            .manager-flag {
              color: #01d28e;
            }
            .el-tooltip {
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>
